var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video__object__actions bar",
      attrs: { "data-ui-section": "video-actions" }
    },
    [
      _c(
        "ul",
        { staticClass: "bar__ul" },
        [
          _c(
            "VideoAction",
            {
              staticClass: "video__object__actions__heart",
              attrs: {
                "button-class": "md-heart action-bar__login__btn",
                dataset: {
                  totalHearts: _vm.video.likeCount,
                  videoUid: _vm.video.id,
                  videoTitle: _vm.video.title,
                  loginReason: _vm.$t("login-reason.heart")
                }
              }
            },
            [
              _c("span", { staticClass: "md-heart" }),
              _vm._v(
                " " +
                  _vm._s(_vm._f("thousandify")(_vm.video.likeCount)) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "VideoAction",
            {
              attrs: {
                "button-class": "md-download js-video__download",
                dataset: {
                  eventCategory: "app-campaign",
                  eventAction: "download-button",
                  eventLabel: _vm.video.title
                }
              },
              nativeOn: {
                click: function($event) {
                  return _vm.handleDownloadButtonClicked($event)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("video._action_bar.download")) +
                  "\n      "
              ),
              _c(
                "div",
                {
                  staticClass:
                    "video__object__actions__tooltip video__object__actions__tooltip--download hidden",
                  attrs: { slot: "block" },
                  slot: "block"
                },
                [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$t("video._action_bar.download_popup.cta"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("ul", [
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://play.google.com/store/apps/details?id=com.viddsee&referrer=utm_source%3Dviddsee%26utm_medium%3Ddownload_desktop%26utm_campaign%3Ddownload_desktop",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Google Play")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "http://itunes.apple.com/app/viddsee-watch-asian-movies/id930821146",
                            target: "_blank"
                          }
                        },
                        [_vm._v("App Store")]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "video._action_bar.download_popup.away_from_your_phone"
                          )
                        ) +
                        " "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "js-video__download__text",
                        attrs: { href: "#" }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "video._action_bar.download_popup.text_yourself_the_app"
                            )
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "video__object__actions__tooltip--download__text-app hidden"
                    },
                    [
                      _c(
                        "form",
                        {
                          staticClass: "download-app__form",
                          attrs: { action: "#", method: "get" }
                        },
                        [
                          _c("input", {
                            staticClass: "download-app__content__sms__input",
                            attrs: { id: "phone", type: "tel" }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "download-app__content__sms__submit ladda-button vs-btn-legacy",
                              attrs: {
                                type: "submit",
                                "data-style": "zoom-out"
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "ladda-label md-send" },
                                [_vm._v("Send")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", {
                            staticClass:
                              "download-app__content__sms__message hidden"
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "VideoAction",
            {
              staticClass: "video__object__actions__add-to-playlist",
              attrs: {
                "button-class": "md-playlist-add action-bar__login__btn",
                dataset: {
                  videoUid: _vm.video.id,
                  watchLaterText: "playlist",
                  videoTitle: _vm.video.title,
                  loginReason: _vm.$t("login-reason.add-to")
                }
              },
              nativeOn: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handleAddToPlaylist($event)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("playlist.actions.add") +
                      _vm.$t("common.into") +
                      "..."
                  ) +
                  "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "VideoAction",
            {
              staticClass: "video__object__actions__share",
              attrs: {
                "button-class": "fa-share js-video__share",
                dataset: {
                  eventCategory: "social-media",
                  eventAction: "share-button"
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("video._action_bar.share")) +
                  "\n      "
              ),
              _c(
                "ul",
                {
                  staticClass: "share-dropdown",
                  attrs: { slot: "block" },
                  slot: "block"
                },
                [
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "vs-btn btn btn--dim js-video__share__facebook",
                        attrs: {
                          type: "button",
                          "data-type": "facebook",
                          "data-event-category": "social-media",
                          "data-event-action": "facebook",
                          "data-event-label": _vm.video.title
                        }
                      },
                      [_c("i", { staticClass: "fa fa-facebook" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "vs-btn btn btn--dim js-video__share__twitter",
                        attrs: {
                          type: "button",
                          "data-type": "twitter",
                          "data-tweet": _vm.tweet,
                          "data-event-category": "social-media",
                          "data-event-action": "twitter",
                          "data-event-label": _vm.video.title
                        }
                      },
                      [_c("i", { staticClass: "fa fa-twitter" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "vs-btn btn btn--dim js-video__share__email",
                        attrs: {
                          type: "button",
                          "data-type": "email",
                          "data-subject": _vm.email.subject,
                          "data-body0": _vm.email.body0,
                          "data-body1": _vm.email.body1,
                          "data-event-category": "social-media",
                          "data-event-action": "email-me",
                          "data-event-label": _vm.video.title
                        }
                      },
                      [_c("i", { staticClass: "fa fa-envelope-o" })]
                    )
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "VideoAction",
            {
              staticClass: "video__object__actions__embed hidden-sm-down",
              attrs: {
                "button-class": "md-code js-video__embed",
                dataset: {
                  videoTitle: _vm.video.title
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("video._action_bar.embed")) +
                  "\n      "
              ),
              _c(
                "div",
                {
                  staticClass:
                    "video__object__actions__tooltip video__object__actions__tooltip--embed hidden",
                  attrs: { slot: "block" },
                  slot: "block"
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.$t("video.action.embed.text")))]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "video__object__actions__embed-link",
                    attrs: { id: "embed-link", type: "text", readonly: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "vs-btn-legacy",
                      attrs: {
                        id: "embed-link-btn",
                        "data-clipboard-target": "#embed-link",
                        "data-placement": "bottom",
                        title: "Copied!"
                      }
                    },
                    [_c("span", { staticClass: "md-link" })]
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "VideoAction",
            {
              directives: [
                {
                  name: "scroll-to",
                  rawName: "v-scroll-to",
                  value: "#comments",
                  expression: "'#comments'"
                }
              ],
              staticClass: "bar__li--right hidden-md-down",
              attrs: {
                "button-class": "bar__li--comment",
                dataset: {
                  eventCategory: "video",
                  eventAction: "join-conversation",
                  eventLabel: _vm.video.title,
                  commentsLocale: _vm.$t("video.info.comments")
                }
              }
            },
            [
              _c("span", { staticClass: "md-comment" }),
              _vm._v(" " + _vm._s(_vm.video.commentCount) + "\n    ")
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }